import React from 'react';
import { Chip } from '@mui/material';
import { alpha, darken, useTheme } from '@mui/material/styles';

/*
  CategoryChip: soft-tinted chip for category labels.
  Derives a calm background tint and readable dark text from the
  category's own color instead of using a solid saturated fill, so
  rows full of categories stay scannable.

  Props:
   - color: the category's color (hex). Falls back to neutral grey.
   - label, size, sx and any other Chip props pass through.
*/

export default function CategoryChip({ color, label, size = 'small', sx, ...rest }) {
  const theme = useTheme();
  let bg;
  let fg;
  try {
    const base = color || theme.palette.grey[500];
    bg = alpha(base, 0.16);
    fg = darken(base, 0.45);
  } catch {
    bg = theme.palette.grey[100];
    fg = theme.palette.grey[700];
  }
  return (
    <Chip
      label={label}
      size={size}
      sx={{ bgcolor: bg, color: fg, fontWeight: 600, ...sx }}
      {...rest}
    />
  );
}
